function Divider() {
  return <hr className="h-px border-t-border mt-6 mb-6" />;
}

export { Divider };
